module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1b.e7598689.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-3-1b.svg
// module id = 569
// module chunks = 0